/* eslint-disable import/prefer-default-export */

export const UPDATE_BOBCARDS = 'UPDATE_BOBCARDS';
export const LOAD_BOBCARDS = 'LOAD_BOBCARDS';
export const DELETE_BOBCARDS = 'DELETE_BOBCARDS';
